interface Props {
  width?: string;
  height?: string;
}

const Calendar = ({ width = '24', height = '24' }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      style={{ display: 'block' }}
    >
      <path
        d="M8 2a.75.75 0 0 1 .75.75V4h6.5V2.75a.75.75 0 0 1 1.5 0V4H18a2.75 2.75 0 0 1 2.75 2.75v12A2.75 2.75 0 0 1 18 21.5H6A2.75 2.75 0 0 1 3.25 18.75v-12A2.75 2.75 0 0 1 6 4h1.25V2.75A.75.75 0 0 1 8 2zm11.25 7.5H4.75v9.25c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V9.5zm-13.5-4C5.06 5.5 4.75 5.81 4.75 6.75V8h14.5V6.75c0-.69-.56-1.25-1.25-1.25H16.75V6.75a.75.75 0 0 1-1.5 0V5.5h-6.5v1.25a.75.75 0 0 1-1.5 0V5.5H6zm1.25 9.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4.25 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4.25 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-8.5 3.75a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4.25 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
        fill="#4C3422"
      />
    </svg>
  );
};

export default Calendar;
